import { render, staticRenderFns } from "./Centered.vue?vue&type=template&id=687783e0&scoped=true"
import script from "./Centered.vue?vue&type=script&lang=js"
export * from "./Centered.vue?vue&type=script&lang=js"
import style0 from "./Centered.vue?vue&type=style&index=0&id=687783e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687783e0",
  null
  
)

export default component.exports